(function () {
  var timer = null;

  function badges() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-sf-cart-badge]'));
  }

  function labels() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-sf-cart-badge-label]'));
  }

  function applyCount(count) {
    var value = Number(count) || 0;
    badges().forEach(function (el) {
      el.textContent = value > 99 ? '99+' : String(value);
      el.classList.toggle('is-hidden', value < 1);
    });
    labels().forEach(function (el) {
      el.textContent = value === 1 ? '1 item in cart' : value + ' items in cart';
    });
    document.documentElement.setAttribute('data-sf-cart-count', String(value));
  }

  function requestCart() {
    var endpoint = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    return fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.item_count !== 'undefined') applyCount(cart.item_count);
      })
      .catch(function () {});
  }

  function queueSync(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(requestCart, typeof delay === 'number' ? delay : 180);
  }

  document.addEventListener('DOMContentLoaded', function () { queueSync(0); });
  window.addEventListener('pageshow', function () { queueSync(0); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') queueSync(0);
  });

  ['cart:refresh', 'cart:update', 'product:added', 'ajaxProduct:added'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var count = event && event.detail && event.detail.cartData && event.detail.cartData.item_count;
      if (typeof count !== 'undefined') {
        applyCount(count);
      } else {
        queueSync(120);
      }
    });
  });

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var request = arguments[0];
      var url = request && request.url ? request.url : String(request || '');
      return originalFetch.apply(this, arguments).then(function (response) {
        if (/\/cart(\/(add|change|update|clear)\.js|\.js)?/.test(url)) queueSync(120);
        return response;
      });
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._sfCartUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      if (this._sfCartUrl && /\/cart(\/(add|change|update|clear)\.js|\.js)?/.test(this._sfCartUrl)) queueSync(120);
    });
    return originalSend.apply(this, arguments);
  };
})();
